import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import UnitFactory from "../../Entity/Factories/UnitFactory";

import Translator from "../../Translation/Translator";

export default function* unitServiceStatusUpdate(action: ActionInterface): any {
  try {
    const res = yield call(Http.patch, `units/${action.payload?.unitId}/service-status`, {serviceStatusId: action.payload?.unitServiceStatusId});
    const unit: UnitInterface = UnitFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_UNIT_UPDATE_SUCCESS,
      payload: {
        unit: unit
      }
    });
    
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-unit-service-status-updated-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_REQUEST
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, unit);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUnitServiceStatusUpdate() {
  yield takeEvery(Constants.GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START, unitServiceStatusUpdate);
}
